import React from 'react';
import { InstagramIcon } from 'lucide-react';
const LOGO_URL = 'https://i.imgur.com/1npk9MS.png';
const CABIN_LINKS = [{
  label: 'Luxury Saman',
  href: '#cabanas'
}, {
  label: 'Chalet Bilibil',
  href: '#cabanas'
}, {
  label: 'Domo Caracolí',
  href: '#cabanas'
}, {
  label: 'Totumo',
  href: '#cabanas'
}, {
  label: 'Ver todas',
  href: '#cabanas'
}];
const REFUGE_LINKS = [{
  label: 'Experiencias',
  href: '#experiencias'
}, {
  label: 'Instalaciones',
  href: '#instalaciones'
}, {
  label: 'Pet Friendly',
  href: '#instalaciones'
}, {
  label: 'Cómo Llegar',
  href: '#como-llegar'
}];
function WhatsAppGlyph() {
  return <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-none stroke-white/70 stroke-[1.5] transition-colors group-hover:stroke-gold" aria-hidden="true" data-id="element-183" data-mp="3ldu52vfywpxe">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-184" data-mp="29zgkbzgigqll" />
    </svg>;
}
interface FooterProps {
  onOpenPrivacyPolicy: () => void;
}
export function Footer({
  onOpenPrivacyPolicy
}: FooterProps) {
  return <footer className="bg-night border-t border-white/10 px-6 sm:px-8 lg:px-12 pt-16 md:pt-20 pb-8" data-id="element-185" data-mp="3gca7r8seo3du">
      <div className="max-w-6xl mx-auto" data-id="element-186" data-mp="3v91a9qxdlv7o">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-10 lg:gap-16 pb-14 border-b border-white/10 mb-10" data-id="element-187" data-mp="3q83svgk6x578">
          <div data-id="element-188" data-mp="81fq3xcm4u4q">
            <img src={LOGO_URL} alt="Refugio Caracolí" className="h-13 w-auto max-w-[145px] object-contain object-left mb-5" data-id="element-189" data-mp="80xk4905f1jm" />
            <p className="text-[0.85rem] text-white/70 leading-[1.75] max-w-[250px]" data-id="element-190" data-mp="hsk3wtqjy8xz">
              Glamping de lujo en el corazón del Tolima. Naturaleza, lujo y descanso. Payandé, San Luis, Tolima.
            </p>
          </div>

          <div data-id="element-191" data-mp="qujm3pdazj2i">
            <h4 className="text-[0.65rem] font-semibold tracking-[0.22em] uppercase text-gold mb-5" data-id="element-192" data-mp="qu1g410u9qhe">Cabañas</h4>
            <ul className="flex flex-col gap-3 list-none" data-id="element-193" data-mp="mtra4od1r02j">
              {CABIN_LINKS.map(link => <li key={link.label} data-id="element-194" data-mp="tt07un1zcgow">
                  <a href={link.href} className="text-[0.85rem] text-white/70 transition-colors hover:text-gold" data-id="element-195" data-mp="yto9e2nu4fxd">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-196" data-mp="18kskuseaxing">
            <h4 className="text-[0.65rem] font-semibold tracking-[0.22em] uppercase text-gold mb-5" data-id="element-197" data-mp="18lbvdo1mh4rg">El Refugio</h4>
            <ul className="flex flex-col gap-3 list-none" data-id="element-198" data-mp="1cnyqbxtlb5sv">
              {REFUGE_LINKS.map(link => <li key={link.label} data-id="element-199" data-mp="1hmibvx49ufkp">
                  <a href={link.href} className="text-[0.85rem] text-white/70 transition-colors hover:text-gold" data-id="element-200" data-mp="1mjihk6x7lgba">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-201" data-mp="3oczot9hfgf5i">
            <h4 className="text-[0.65rem] font-semibold tracking-[0.22em] uppercase text-gold mb-5" data-id="element-202" data-mp="3odhwd29jifsq">Contacto</h4>
            <ul className="flex flex-col gap-3 list-none" data-id="element-203" data-mp="2af3ubumo9blq">
              <li data-id="element-204" data-mp="2ageuzlktm38m">
                <a href="tel:+573244688664" className="text-[0.85rem] text-white/70 transition-colors hover:text-gold" data-id="element-205" data-mp="2agyeh6q4czor">
                  324 468 8664
                </a>
              </li>
              <li data-id="element-206" data-mp="21kpe9pubhx1k">
                <a href="mailto:refugiocaracoli@gmail.com" className="text-[0.85rem] text-white/70 transition-colors hover:text-gold" data-id="element-207" data-mp="1wnp8zh5akybi">
                  refugiocaracoli@gmail.com
                </a>
              </li>
              <li data-id="element-208" data-mp="2pbutq3wcinbc">
                <a href="https://www.instagram.com/refugio.caracoli/" target="_blank" rel="noopener noreferrer" className="text-[0.85rem] text-white/70 transition-colors hover:text-gold" data-id="element-209" data-mp="2pdfp1vqhiaa9">
                  @refugio.caracoli
                </a>
              </li>
              <li data-id="element-210" data-mp="18y4pmx587z1p">
                <button onClick={onOpenPrivacyPolicy} className="text-[0.85rem] text-white/70 transition-colors hover:text-gold text-left" data-id="element-211" data-mp="18ynvvglikyzw">
                  Política de Privacidad
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-between gap-6 flex-wrap sm:flex-nowrap" data-id="element-212" data-mp="2rtwjpswmui7k">
          <p className="text-[0.76rem] text-white/50" data-id="element-213" data-mp="2wok9rw7abko9">
            2025 Refugio Caracolí · Vereda El Retiro, Payandé, San Luis, Tolima · Todos los derechos reservados
          </p>
          <div className="flex gap-3.5 shrink-0" data-id="element-214" data-mp="2nue153saaj7w">
            <a href="https://www.instagram.com/refugio.caracoli/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="group w-[33px] h-[33px] rounded-full border border-white/20 flex items-center justify-center transition-all hover:border-gold hover:bg-gold/10" data-id="element-215" data-mp="3bj71rdjupf8u">
              <InstagramIcon className="w-3.5 h-3.5 text-white/70 transition-colors group-hover:text-gold" strokeWidth={1.5} data-id="element-216" data-mp="36mgnmvrlwtq2" />
            </a>
            <a href="https://wa.me/573244688664" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="group w-[33px] h-[33px] rounded-full border border-white/20 flex items-center justify-center transition-all hover:border-gold hover:bg-gold/10" data-id="element-217" data-mp="1v5qkxmme6k17">
              <WhatsAppGlyph data-id="element-218" data-mp="1wk9tz6ewm93r" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}